import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const checkAuth = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            setUser(false);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (window.location.hash?.includes("session_id=")) {
            setLoading(false);
            return;
        }
        checkAuth();
    }, [checkAuth]);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        setUser(data);
        return data;
    };
    const register = async (payload) => {
        const { data } = await api.post("/auth/register", payload);
        setUser(data);
        return data;
    };
    const logout = async () => {
        await api.post("/auth/logout");
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, register, logout, setUser, checkAuth }}>
            {children}
        </AuthContext.Provider>
    );
}
